<script lang="ts">
	import ScrollReveal from '$lib/components/ScrollReveal.svelte';
	import ServiceCard from './ServiceCard.svelte';
	import { t, type Language } from '$lib/i18n';
	import { getServices } from '$lib/data/services';

	interface Props {
		lang: Language;
	}

	let { lang }: Props = $props();
	let tr = $derived(t(lang));
	let services = $derived(getServices(lang));

	let knowServices = $derived(services.filter((s) => s.category === 'know'));
	let platformServices = $derived(services.filter((s) => s.category === 'platform'));
</script>

<section id="services" class="py-16 md:py-32 relative section-gradient-reverse">
	<div class="max-w-7xl mx-auto px-6">
		<ScrollReveal>
			<div class="max-w-3xl mb-10 md:mb-20">
				<p class="text-ameta-green font-medium mb-4 tracking-wide">{tr('services_label')}</p>
				<h2 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
					{tr('services_title')}
				</h2>
				<p class="text-xl text-slate-400 leading-relaxed">
					{tr('services_subtitle')}
				</p>
			</div>
		</ScrollReveal>

		<!-- Analytics section -->
		<div class="mb-12">
			<ScrollReveal>
				<div class="flex items-center gap-3 mb-6">
					<div class="w-2 h-2 rounded-full bg-ameta-green"></div>
					<p class="text-sm font-medium text-slate-400 uppercase tracking-wider">
						{tr('services_category_know')}
					</p>
				</div>
			</ScrollReveal>
			<div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
				{#each knowServices as service, i}
					<ServiceCard {service} delay={i * 100} iconColor="text-ameta-green" />
				{/each}
			</div>
		</div>

		<!-- Platform section -->
		<div>
			<ScrollReveal>
				<div class="flex items-center gap-3 mb-6">
					<div class="w-2 h-2 rounded-full bg-slate-400"></div>
					<p class="text-sm font-medium text-slate-400 uppercase tracking-wider">
						{tr('services_category_platform')}
					</p>
				</div>
			</ScrollReveal>
			<div class="grid md:grid-cols-2 gap-5">
				{#each platformServices as service, i}
					<ServiceCard {service} delay={i * 100} iconColor="text-slate-300" />
				{/each}
			</div>
		</div>
	</div>
</section>
